<script lang="ts" setup>
import { useSidebar } from '../ui/sidebar/utils'
import { useAuthStore } from '~/store/authStore'

const { open } = useSidebar()
const authStore = useAuthStore()
const localePath = useLocalePath()
</script>

<template>
  <UiSidebarFooter v-if="open">
    <UiButton
      variant="success"
      size="sm"
      @click="authStore.activateTabletMode"
    >
      <Icon name="tabler-device-tablet" />
      {{ $t('Tablet mode') }}
    </UiButton>
    <UiButton
      variant="outline"
      size="sm"
      target="_blank"
      to="https://about.dartsspace.com/en/documentation"
    >
      <Icon name="tabler-book" />
      {{ $t('Documentation') }}
    </UiButton>
    <div class="flex flex-col">
      <div class="flex flex-wrap flex-row gap-1 text-xs underline">
        <NuxtLink to="/en/privacy-policy">
          Privacy Policy
        </NuxtLink>
        <NuxtLink to="/en/terms-of-service">
          Terms of Service
        </NuxtLink>
        <NuxtLink
          v-if="authStore.shouldShowManage"
          :to="localePath('/admin/users')"
        >
          ADM: Users
        </NuxtLink>
      </div>
    </div>
  </UiSidebarFooter>
</template>
